<template>
  <div
    id="app"
    style="
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;"
  >
    <router-view />
  </div>
</template>

<script>
import { initWebSocket } from "@/utils";
export default {
  name: "app",
  created() {
    window.onload = () => {
      this.openSocket();
    };
  },
  methods: {
    openSocket() {
      const user = sessionStorage.getItem("user") || "";
      const token = sessionStorage.getItem("token") || "";
      if (user) {
        initWebSocket(token, JSON.parse(user));
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue